import { create } from 'zustand'

interface EditorData {
  itemId: string
  itemType: PepperDocTypes
  docId: string
  editorToken: string
}

interface EditorStore {
  editorData: EditorData | null
  setEditorData: (data: EditorData) => void
  clearEditorData: () => void
}

export const useEditorStore = create<EditorStore>()(set => ({
  editorData: null,
  setEditorData: data => set(() => ({ editorData: data })),
  clearEditorData: () => set(() => ({ editorData: null }))
}))
